import { useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { useAuthStore } from '../store/authStore';
import apiHandler from '../api/apiHandler';

const useAuthToken = () => {
    const { isAuthenticated, getAccessTokenSilently } = useAuth0();
    const setToken = useAuthStore((state) => state.setToken);

    useEffect(() => {
        const fetchToken = async () => {
            if (isAuthenticated) {
                try {
                    const token = await getAccessTokenSilently();
                    const challenge = await apiHandler({
                        endpoint: '/auth/challenge',
                        method: 'POST',
                        params: {
                            accessToken: token,
                        },
                    });
                    if (challenge?.access_token) {
                        setToken(challenge?.access_token);
                    } else {
                        console.error('Error getting the token:', challenge);
                    }
                } catch (error) {
                    console.error('Error fetching token:', error);
                }
            }
        };

        fetchToken();
    }, [isAuthenticated, getAccessTokenSilently, setToken]);
};

export default useAuthToken;
